import React from 'react'
import { IoLogoAppleAppstore } from 'react-icons/io5';
import { IconProps } from '../types';



export const SwiftIcon = (props: IconProps) => {
    return (
        <IoLogoAppleAppstore {...props} />
    )
}


SwiftIcon.displayName = "SwiftIcon"
